import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import SecurityIcon from '@mui/icons-material/Security';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { CognitoUser } from 'amazon-cognito-identity-js';
import React from 'react';
import { isMfaMethod, useMfaStatus } from '../../hooks/use-mfa-status';
import { getOptionName, MfaSetupDrawer } from './mfa-setup-drawer';

/**
 * "MFA Settings" on the Agent Profile (and Home, for staff): the current
 * method and a Manage button that opens the set-up drawer.
 */
export function MultiFactorInfo(props: { user: CognitoUser }) {
  // State
  const [open, setOpen] = React.useState(false);
  // Hooks
  const query = useMfaStatus();

  const preferred = query.data?.preferred;
  const hasPreferred = isMfaMethod(preferred);

  return (
    <React.Fragment>
      <Paper elevation={0} sx={{ p: 1, border: '1px solid #00000022' }}>
        <Stack spacing={1} direction="row" alignItems="center">
          <SecurityIcon fontSize="large" sx={{ color: '#b26500' }} />

          <Box>
            <Box sx={{ fontSize: 28, fontWeight: 'bold', lineHeight: 1 }}>
              MFA Settings
            </Box>
            <Box sx={{ fontSize: 14, color: '#9b9b9b' }}>
              Multi-Factor Authentication
            </Box>
          </Box>

          <Box sx={{ flex: 1 }} />

          <Stack
            spacing={1}
            direction={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'flex-end', sm: 'center' }}
          >
            {query.isLoading ? (
              <CircularProgress size={32} />
            ) : hasPreferred ? (
              <Chip
                avatar={<TaskAltIcon color="inherit" />}
                label={getOptionName(preferred || '')}
                size="medium"
                color="success"
                variant="outlined"
              />
            ) : (
              <Chip
                avatar={<WarningAmberIcon color="inherit" />}
                label="None selected"
                size="medium"
                color="warning"
                variant="outlined"
              />
            )}

            <Button
              disabled={query.isLoading || query.isError}
              size="small"
              disableElevation
              variant="contained"
              endIcon={<ArrowForwardIcon fontSize="small" />}
              onClick={() => setOpen(true)}
            >
              Manage
            </Button>
          </Stack>
        </Stack>
      </Paper>

      <MfaSetupDrawer
        user={props.user}
        open={open}
        onClose={() => setOpen(false)}
      />
    </React.Fragment>
  );
}
